import React from "react";
//#region types
import { FileProfileProps } from "models/propTypes/userProfilePropTypes";
//#endregion
//#region components
import { Avatar, Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { FileHelper } from "utils/helpers";

const FileProfile: React.FC<FileProfileProps> = (props) => {
  const fileIcon = FileHelper.getIconTextByContentType(props.contentType);
  return (
    <Grid item container spacing={1} alignItems="center">
      <Grid item>
        <Avatar
          className={clsx(
            cssExports.uploadedFileIcon,
            fileIcon?.iconColor,
            fileIcon?.iconText && fileIcon.iconText.length > 3 ? cssExports.uploadedFileIconSmall : ""
          )}
        >
          {fileIcon?.iconText}
        </Avatar>
      </Grid>
      <Grid item xs>
        {props.fileName}
      </Grid>
    </Grid>
  );
};

export default FileProfile;
